import { useState } from 'react';
import {
  InventoryViewBody,
  InventoryViewHeader,
  InventoryViewPage,
} from './InventoryViewComponents';
import {
  containerListModal,
  ContainerListModal,
  fullScreenButtonClick,
  ImageGallery,
  InventoryCompleteModal,
  InventoryItemUpdateModal,
} from '../../design-system';
import { RoleGuard } from '../../routes';

const getClientItems = (fcProps: any, data: any) => {
  const clientItems = fcProps.containerNumber.map((number: string) => {
    const item = data.items.find((item: any) => item.number === number);
    if (item)
      return {
        ...item,
        clientStatus:
          item.clientYard?.client.code === containerListModal.clientCode ? 'FOUND' : 'NOT_FOUND',
      };

    return {
      number,
      clientStatus: 'FOUND',
      status: 'NOT_FOUND',
    };
  });
  const items = data.items
    .filter((item: any) => item.clientYard?.client.code === containerListModal.clientCode)
    .filter(
      (item: any) => !clientItems.some((clientItem: any) => clientItem.number === item.number),
    )
    .map((item: any) => ({ ...item, clientStatus: 'NOT_FOUND' }));
  return [...clientItems, ...items];
};

export const InventoryView = () => {
  const [data, setData] = useState<any>();
  const [clientData, setClientData] = useState<any>();
  const [images, setImages] = useState<any>([]);

  const handleCheckWithClientReportClick = () => {
    const fc = (fcProps: any = { containerNumber: [] }) => {
      setClientData({
        items: getClientItems(fcProps, data),
      });
    };
    containerListModal.yardId = data?.yard?.id;
    containerListModal.fc = fc;
    containerListModal.isFilterList = true;
    containerListModal.open();
  };

  const handleCancelClick = () => {
    setClientData(undefined);
  };

  const handleClickImage = (images: any[]) => {
    if (images.length === 0) return;

    setImages(images.map(({ url }) => url));
    fullScreenButtonClick();
  };

  return (
    <RoleGuard roles={['SUPER_ADMIN', 'YARD_COMPANY_ADMIN', 'YARD_COMPANY_VIEWER', 'YARD_MANAGER']}>
      <InventoryViewPage>
        <InventoryViewHeader
          yardName={data?.yard?.name}
          yardId={data?.yard?.id}
          clientData={clientData}
          handleCheckWithClientReportClick={handleCheckWithClientReportClick}
          handleCancelClick={handleCancelClick}
        />
        <InventoryViewBody
          setData={setData}
          clientData={clientData}
          handleClickImage={handleClickImage}
        />
      </InventoryViewPage>
      <InventoryItemUpdateModal />
      <InventoryCompleteModal />
      <ContainerListModal />
      <ImageGallery photos={images} startIndex={0} />
    </RoleGuard>
  );
};
